export default {
    drap_drop_container_success_message: "The record was successfully deleted",
    drap_drop_container_delete_gadget: "Delete Gadget"
}